<script lang="ts" setup>
import BasicInput from '~/components/form-elements/BasicInput.vue'
import BasicInputDecorator from '~/components/form-elements/BasicInputDecorator.vue'
import { useSearchboosterStore } from '~/store/searchbooster'

const searchboosterStore = useSearchboosterStore()
const { getMaxPrice, getMinPrice } = storeToRefs(searchboosterStore)
</script>

<template>
  <div class="flex items-center justify-between">
    <BasicInputDecorator>
      <BasicInput
        v-model="searchboosterStore.filter.params.price.min"
        class="[&_.basic-input-group]:!rounded-2xl"
        :is-border="false"
        :placeholder="'от ' + getMinPrice"
      />
    </BasicInputDecorator>

    <div class="mx-3">
      <span class="text-[#D1D1D1]">—</span>
    </div>

    <BasicInputDecorator>
      <BasicInput
        v-model="searchboosterStore.filter.params.price.max"
        class="[&_.basic-input-group]:!rounded-2xl"
        :is-border="false"
        :placeholder="'до ' + getMaxPrice"
      />
    </BasicInputDecorator>
  </div>
</template>
